import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useStore } from '../../../app/stores/store';
import DynamicTableComponent from '../../DynamicTable/DynamicTableComponent';
import isEmpty from 'lodash/isEmpty';

function AlertsTable() {
  const { dashboardStore, emailStore } = useStore();
  const { emailAlertSearch, emailAlertSort, emailAlertDetails } = emailStore;

  useEffect(() => {
    emailAlertSearch('', 1);
    // eslint-disable-next-line
  }, []);

  const paginationHandler = (number: any) => {
    emailAlertDetails.pageNumber = number;
    let searchValues = dashboardStore.dashboard.searchfilterparams;
    if (
      !isEmpty(searchValues) &&
      Object.values(searchValues).every((o) => o !== '') &&
      dashboardStore.dashboard.orderData === '' &&
      dashboardStore.dashboard.orderName === ''
    ) {
      emailAlertSearch(searchValues, number);
    } else if (
      dashboardStore.dashboard.orderData !== '' &&
      dashboardStore.dashboard.orderName !== ''
    ) {
      emailAlertSort(
        dashboardStore.dashboard.orderData,
        dashboardStore.dashboard.orderName,
        number,
      );
    } else {
      emailAlertSearch('', number);
    }
  };

  // if (emailAlertDetails.isloading) return <LoadingComponent />;

  return (
    <div className="emailTable">
      <DynamicTableComponent
        data={emailAlertDetails?.data || []}
        name={'AlertsTable'}
        actiontype={'Resolve'}
        searchFuncData={''}
        pageFunc={paginationHandler}
        pageNumData={emailAlertDetails.pageNumber}
        loading={emailAlertDetails.isloading}
      />
    </div>
  );
}

export default observer(AlertsTable);
